import styled from "styled-components";

export const ErrorWrapper = styled.div`
    max-width: 40rem;
    margin: 30vh auto 0 auto;
    background: white;
    border: 1px solid ${props => props.theme.BorderColor};
    padding: 2rem 4rem;
    box-shadow: 0px 3px 15px rgba(0,0,0,0.2);
    
    h1 {
        text-transform: uppercase;
        font-size: 2.4rem;
        margin: 0;
    }

    .error-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 1.6rem;
        margin: 1rem 0;

        .error-icon {
            font-size: 3rem;
            margin-right: 2rem;
            color: ${props => props.theme.WarningColor};
        }
    }
    
    @media (max-width:640px) {
        max-width: 20rem;
        padding: 2rem;
        margin: 20vh auto 0 auto;

        h1 {
            text-transform: uppercase;
            font-size: 1.4rem;
            text-align: center;
        }

        .error-content {
            flex-direction: column;
            font-size: 1.1rem;
            margin: 1rem 0;

            .error-icon {
                font-size: 2rem;
                margin-right: 0;
            }
        }

        .ant-btn {
            height: 24px;
            padding: 2px 8px;
            font-size: 12px;
        }
    }
`;